/**
 * @file
 * Button script.
 */

(function buttonScript(Drupal, once) {
  'use strict';

  function scrollClickKeydownListener(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') {
      return;
    }
    event.preventDefault();
    const link = event.currentTarget;
    if (link.hash) {
      Drupal.ahsThemeSite.scrollToAnchorTarget(link.hash);
    }
  }

  Drupal.behaviors.themeScrollToTop = {
    attach(context) {
      const scrolls = once('themeScrollToTop', '.js-scroll-to-top', context);
      if (!scrolls.length) {
        return;
      }

      scrolls.forEach((scroll) => {
        scroll.addEventListener('click', scrollClickKeydownListener);
        scroll.addEventListener('keydown', scrollClickKeydownListener);
      });
    },
  };
}(Drupal, once));
